import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

export const KOREA_REVENUE_BY_CUSTOMER_SUCCESS = 'KOREA_REVENUE_BY_CUSTOMER_SUCCESS';
export const KOREA_REVENUE_BY_CUSTOMER_LOADING = 'KOREA_REVENUE_BY_CUSTOMER_LOADING';

const { revenueByCustomerForKorea: { getRevenueByCustomerForKorea } } = apiUrls;


export const getKoreaRevenueByCustomerDetails = ({ year }) => async (dispatch) => {
  try {
    const { url } = getRevenueByCustomerForKorea
    const requestData = {
        ...getRevenueByCustomerForKorea,
        url: url.replace('{{year}}', year)
    };
    const data = await REQUEST(requestData);
    dispatch({
      type: KOREA_REVENUE_BY_CUSTOMER_SUCCESS,
      data,
    })
  } catch (e) {

    dispatch({
      type: KOREA_REVENUE_BY_CUSTOMER_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      }
    })
  }

}

export const handleLoader = isLoading => (dispatch) => {
  dispatch({
    type: KOREA_REVENUE_BY_CUSTOMER_LOADING,
    isLoading
  })
}
